import React, { useState, useEffect, useRef } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import './Testimonials.scss';
import { getLanguage } from '../../utils/Helper';

const TESTIMONIALS_DATA = [
  {
    id: 1,
    name: "أحمد حسن",
    image: "https://ui-avatars.com/api/?name=Ahmed+Hassan&background=F5A623&color=fff&size=150&bold=true",
    rating: 5,
    review: "المكان تحفة بجد و فيه varieties كتير و اسعارهم مقارنة بالباقي رخيصة 😍 أنصح بيه جداً!"
  },
  {
    id: 2,
    name: "فاطمة محمد",
    image: "https://ui-avatars.com/api/?name=Fatima+Mohammed&background=EC4899&color=fff&size=150&bold=true",
    rating: 5,
    review: "جودة استثنائية وتصميمات أنيقة. دايماً بلاقي اللي بدور عليه هنا. خدمة العملاء ممتازة! ❤️"
  },
  {
    id: 3,
    name: "عمر خالد",
    image: "https://ui-avatars.com/api/?name=Omar+Khaled&background=14B8A6&color=fff&size=150&bold=true",
    rating: 4.5,
    review: "تجربة رائعة في التسوق هنا. الموظفين متعاونين جداً والمنتجات من أعلى مستوى. أكيد هرجع تاني!"
  },
  {
    id: 4,
    name: "نور سمير",
    image: "https://ui-avatars.com/api/?name=Nour+Samir&background=8B5CF6&color=fff&size=150&bold=true",
    rating: 5,
    review: "جهزت بيتي كله من عندهم مجموعة رمضان تحفة فنية. الأسعار معقولة والجودة ممتازة!"
  },
  {
    id: 5,
    name: "يوسف علي",
    image: "https://ui-avatars.com/api/?name=Youssef+Ali&background=F59E0B&color=fff&size=150&bold=true",
    rating: 5,
    review: "منتجات بجودة عالية وتصميمات مميزة. التنوع مبهر وتجربة التسوق سلسة وممتعة"
  },
  {
    id: 6,
    name: "ليلى إبراهيم",
    image: "https://ui-avatars.com/api/?name=Layla+Ibrahim&background=06B6D4&color=fff&size=150&bold=true",
    rating: 4.5,
    review: "بحب الذوق والاهتمام بالتفاصيل! المحل له أجواء رائعة والمنتجات مختارة بعناية. رووعة! 💖"
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const autoPlayRef = useRef(null);
  const lang = getLanguage();

  // Intersection Observer for reveal animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1, rootMargin: '100px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Auto-play functionality
  useEffect(() => {
    if (isAutoPlaying) {
      autoPlayRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % TESTIMONIALS_DATA.length);
      }, 3000); // Change every 3 seconds
    }

    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [isAutoPlaying]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000); // Resume after 10s
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + TESTIMONIALS_DATA.length) % TESTIMONIALS_DATA.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % TESTIMONIALS_DATA.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <Star key={`full-${i}`} size={18} fill="#F5A623" color="#F5A623" />
      );
    }

    if (hasHalfStar) {
      stars.push(
        <div key="half" className="star-half">
          <Star size={18} fill="#F5A623" color="#F5A623" style={{ clipPath: 'inset(0 50% 0 0)' , position: 'absolute', left: 0, top: 0}} />
          <Star size={18} fill="none" color="#F5A623" style={{ position: 'absolute', left: 0, top: 0 }} />
        </div>
      );
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <Star key={`empty-${i}`} size={18} fill="none" color="#F5A623" />
      );
    }

    return stars;
  };

  // Calculate visible cards (show 3 at a time on desktop, 2 on mobile)
  const getVisibleTestimonials = () => {
    const visibleCount = window.innerWidth >= 1024 ? 3 : 2;
    const start = currentIndex;
    const end = (currentIndex + visibleCount) % TESTIMONIALS_DATA.length;

    if (end > start) {
      return TESTIMONIALS_DATA.slice(start, end);
    } else {
      return [...TESTIMONIALS_DATA.slice(start), ...TESTIMONIALS_DATA.slice(0, end)];
    }
  }

  // const getVisibleTestimonials = () => {
  //   const testimonials = [];
  //   for (let i = 0; i < 3; i++) {
  //     const index = (currentIndex + i) % TESTIMONIALS_DATA.length;
  //     testimonials.push(TESTIMONIALS_DATA[index]);
  //   }
  //   return testimonials;
  // };

  return (
    <section 
      className={`testimonials ${isVisible ? 'testimonials--visible' : ''}`}
      style={{ backgroundImage: "url('/assets/black background.jpg')" }}
      ref={sectionRef}
      onMouseEnter={() => setIsAutoPlaying(false)}
      onMouseLeave={() => setIsAutoPlaying(true)}
    >
      <div className="testimonials__container">
        {/* Header */}
        <div className="testimonials__header">
          <div className="testimonials__badge">
            {lang === 'AR' ? 'تقييمات العملاء' : 'Customer Reviews'}
          </div>
          <h2 className="testimonials__title">
            {lang === 'AR' ? 'تجارب عملائنا' : ' Our Customers\' Experiences'}
          </h2>
          <p className="testimonials__subtitle">
            {lang === 'AR' ? 'اكتشف قصص النجاح الحقيقية! انضم للآخرين في تجربة تنوع ومصداقية منصتنا.' : 'Discover real success stories! Join others in experiencing the diversity and credibility of our platform.'}
          </p>
        </div>

        {/* Testimonials Slider */}
        <div className="testimonials__slider">
          {/* Navigation Buttons */}
          <button 
            className="testimonials__nav testimonials__nav--left"
            onClick={goToPrevious}
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={24} />
          </button>

          <button 
            className="testimonials__nav testimonials__nav--right"
            onClick={goToNext}
            aria-label="Next testimonial"
          >
            <ChevronRight size={24} />
          </button>

          {/* Cards Container */}
          <div className="testimonials__track">
            {getVisibleTestimonials().map((testimonial, index) => (
              <div 
                key={`${testimonial.id}-${index}`}
                className={`testimonial-card ${index === 0 ? 'testimonial-card--active' : ''}`}
                style={{ animationDelay: isVisible ? `${index * 0.15}s` : '0s' }}
              >
                {/* Quote Icon */}
                <div className="testimonial-card__quote">
                  <Quote size={32} />
                </div>

                {/* Customer Info */}
                <div className="testimonial-card__header">
                  <div className="testimonial-card__avatar">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <div className="testimonial-card__info">
                    <h4 className="testimonial-card__name">
                      {testimonial.name}
                    </h4>
                  </div>
                </div>

                {/* Review Text */}
                <p className="testimonial-card__review">
                  {testimonial.review}
                </p>

                {/* Rating */}
                <div className="testimonial-card__rating">
                  {renderStars(testimonial.rating)}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots Navigation */}
        <div className="testimonials__dots">
          {TESTIMONIALS_DATA.map((_, index) => (
            <button
              key={index}
              className={`testimonials__dot ${index === currentIndex ? 'testimonials__dot--active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;